import browseDevice from "../utils/BrowseDevice";


/**
 * [技業logのサムネイルブロック生成]
 * @export
 * @class TecItemCreateTop
 */
export class TecItemCreateTop {

	constructor() {
	}

	public createItem(e): any {
		
		var result_data: any[] = [];
		var entry = e.entry;
		var data: any;
		var j;
		var class_name;

		if (!browseDevice.judgeBrowse().isIE && !browseDevice.judgeBrowse().isEdge) {
			class_name = ' imgcut03';
		}

		for (var i = 0; i < entry.length; i++) {
            var result_str: string = '';
			data = entry[i];
			let isOld: boolean = false;
			// カテゴリタグ生成
			let tag = '';
			for (j = 0; j < data.category.length; j++) {
				tag += '<li class="fill__info--category">' + this.getCategoryName(data.category[j], e.category) + '</li>';
			}

			// 執筆者情報生成
			let name = '';
			for (j = 0; j < data.writersid.length; j++) {
				let writer = this.getWriter(data.writersid[j], e.writers);
				name += '<div class="m_photoBox__writer"><div class="m_photoBox__portrait"><img src="' + writer.thumburl + '" alt="' + writer.name + '"></div><p class="m_photoBox__text">' + writer.name + '</p></div>';
			}

			// gpu側の記事はドメインを付与して_blank設定
			let target_str = '';
			if (data.url.substr(0, 4) === '/gpu') {
				target_str = 'target="_blank"';
				data.url = 'https://www.nttpc.co.jp' + data.url;
			}

			const year: number = Number(data.date.split('.')[0]);;
			if (year <= 2016) isOld = true;
            let hrefTarget = '';
            if(data.url.includes('/gpu/')) hrefTarget = ' target="_blank"'
			result_str = `
                <li>
            <a href="${ data.url}"${hrefTarget}>
            <div class="fill__image"><img src="${data.thumbpass}" alt="${data.title}"></div>
            <div class="fill__desc">
            <h3 class="fill__sub u_nsjp">${data.title}</h3>
            <ul class="fill__info">
            ${tag}
            <li class="fill__info--date">${data.date}</li>
            </ul>
            </div>
            </a>
            </li>
            `;

			// result_data.push({
			// 	tag: tag,
			// 	date: data.date,
			// 	visual: data.visual,
			// 	thumb: data.thumbpass,
			// 	url: data.url,
			// 	writer: name,
			// 	title: data.title,
			// 	old: isOld
			// });

            result_data.push(result_str);
		}
        // console.log(result_str);
		return { src_data: result_data };
	}

	/**
	 * カテゴリ入欄からcategoryIdと合致するカテゴリ名を返却
	 *
	 * @private
	 * @param {string} categoryId
	 * @param {*} searchTarget
	 * @returns
	 * @memberof TechWriter
	 */
	private getCategoryName(categoryId: string, searchTarget) {
		for (var i = 0; i < searchTarget.length; i++) {
			if (categoryId === searchTarget[i].id) {
				return searchTarget[i].label;
			}
		}
	}

	/**
	 * 執筆者一覧からwriterIdと合致する執筆者情報を返却
	 *
	 * @private
	 * @param {string} writerId
	 * @param {*} searchTarget
	 * @returns
	 * @memberof TechWriter
	 */
	private getWriter(writerId: string, searchTarget) {
		for (var i = 0; i < searchTarget.length; i++) {
			if (writerId === searchTarget[i].id) {
				return searchTarget[i];
			}
		}
	}
}